import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "lock",
  style: {"height":"20px","width":"24px","border-radius":"26px","background-color":"#5731f5","padding-left":"7px"}
}
const _hoisted_2 = ["src"]

import lock from '@/assets/svg/lock.svg'

export default /*@__PURE__*/_defineComponent({
  __name: 'LockIndicator',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      style: {"vertical-align":"baseline"},
      src: _unref(lock)
    }, null, 8, _hoisted_2)
  ]))
}
}

})